import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import routes from "./routes";
import VueCookies from "vue-cookies";
import jQuery from "jquery";
import config from "./config.js";
import Autocomplete from '@trevoreyre/autocomplete-vue'


/* import font awesome icon core, specific icons, component */
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMagnifyingGlass,
  faArrowDown,
  faArrowUp,
  faBars,
} from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import AutoComplete from 'primevue/autocomplete';
/* add icons to the library */
library.add(faMagnifyingGlass);
library.add(faArrowDown);
library.add(faArrowUp);
library.add(faCircleXmark);
library.add(faBars);
/* add font awesome icon component */
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;
// End of added things

window.jQuery = jQuery;
console.log("Vue" + Vue.version);
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(Autocomplete);
const router = new VueRouter({ mode: "history", routes });
router.beforeEach(async (to, from, next) => {
  if (to.name !== "login") {
    if (!((from.name == "login" && to.name == "verify") || from.name == "verify") ) {
      const response = await fetch(config.baseURL + "/verify_token", {
        credentials: "include",
        headers: {
          "Authorization": Vue.$cookies.get("id")
        }
      });
      const data = await response.json();
      if (data["Accepted"]) next();
      else if (
        !data["Accepted"] &&
        data["reason"] === "User Not Authenticated."
      )
        next({ name: "login" });
      else if (!data["Accepted"] && data["reason"] === "Oops! Session Expired.")
        next({ name: "login" });
      else next({ name: "login" });
      console.log(to);
      console.log(from);
    } else next();
  } else next();
});
new Vue({
  router: router,
  render: (h) => h(App),
}).$mount("#app");
